module.exports = __webpack_public_path__ + "img/img2.d688bd89.png";